import _kebabCase from 'lodash/kebabCase';
import { Google, Pixall } from '../analytics/index.js';
/**
 * @summary Sends Google event when hero ad cta clicked
 * @events event1
 */
export async function heroAdCTAClick(_ref, option) {
  let {
    data = {},
    dataLayer
  } = _ref;
  const {
    text = '',
    type = '',
    catalog = 'atc',
    makeId = '',
    makeName = '',
    modelId = '',
    modelName = '',
    year = '',
    es = '',
    ...rest
  } = data;
  Google.sendClickEvent({
    eventResult: `${type}::hero-ad::${_kebabCase(text)}`,
    eventElement: 'partner',
    eventNonInteractive: true,
    eventData: {
      catalog,
      makeId,
      makeName,
      modelId,
      modelName,
      year
    }
  }, option);
  Pixall.sendClickEvent({
    eventSource: es || 'link',
    label: `${type}::hero-ad::${_kebabCase(text)}`
  }, dataLayer, option);
  return rest;
}
export default {
  heroAdCTAClick
};